<!--<template>-->
<!--  <section class="app-main">-->
<!--    <transition name="fade" mode="out-in">-->
<!--      <keep-alive :include="cachedViews">   &lt;!&ndash; 新增  &ndash;&gt;-->
<!--        <router-view :key="key" />-->
<!--      </keep-alive>-->
<!--    </transition>-->
<!--  </section>-->
<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  name: 'AppMain',-->
<!--  computed: {-->
<!--    // key() {-->
<!--    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()-->
<!--    // }-->
<!--  }-->
<!--}-->
<!--</script>-->
<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
  export default {
    name: 'AppMain',
    computed: {
      cachedViews() {
        return this.$store.state.tagsView.cachedViews
      },
      key() {
        return this.$route.path
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app-main {
    /* 50= navbar  50  */
    min-height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  .fixed-header+.app-main {
    padding-top: 50px;
  }
  .hasTagsView {
    .app-main {
      /* 84 = navbar + tags-view = 50 + 34 */
      min-height: calc(100vh - 120px);
      overflow: auto;
    }
    .fixed-header+.app-main {
      padding-top: 84px;
    }
  }
</style>

<style lang="scss">
  // fix css style bug in open el-dialog
  .el-popup-parent--hidden {
    .fixed-header {
      padding-right: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue